import { RegisterControl } from "@eavfw/apps";

import { PowerBiDashboard } from "./PowerBiDashboard";

RegisterControl("PowerBiDashboard", PowerBiDashboard);